import { Modal, Stack, Title } from '@mantine/core';

import { ButtonMantine } from '../../../../Buttons';
import { Card } from '../../../../DataDisplay';
import { Text } from '../../../../Typography';
import { DarkModalHeader } from '../../../molecules';
import classes from './RemoveFromMyCausesModal.module.css';

type RemoveFromMyCausesModalProps = {
  opened: boolean;
  onClose: () => void;
  onRemoveFromMyCauses: () => void;
  causeImg?: string;
  causeName?: string;
  isLoading?: boolean;
};

const RemoveFromMyCausesModal = ({
  opened,
  onClose,
  onRemoveFromMyCauses,
  causeImg,
  causeName,
  isLoading = false,
}: RemoveFromMyCausesModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={isLoading ? () => void 0 : onClose}
      title={
        <DarkModalHeader causeImg={causeImg}>
          {(emphasize) => <>Remove {emphasize?.(causeName ?? '')} from My Causes</>}
        </DarkModalHeader>
      }
    >
      <Stack>
        <Title order={2}>Remove from My Causes</Title>
        <Card className={classes.RemoveFromMyCausesModal__infoCard}>
          <Stack gap="sm">
            <Stack gap={4}>
              <Text type="sub" fw={600}>
                You will no longer...
              </Text>
              <Text type="sub" c="gray">
                receive notifications, access exclusive store products, or make quick donations
                related to the cause you've unfavored.
              </Text>
            </Stack>
            <Stack gap={4}>
              <Text type="sub" fw={600}>
                Cashback Allocation
              </Text>
              <Text type="sub" c="gray">
                Any cashback earnings allocated to this cause will now be redirected to your wallet.
                Rest assured, your cashback rewards are safe and ready for you to use as you see
                fit.
              </Text>
            </Stack>
          </Stack>
        </Card>
        <ButtonMantine
          onClick={onRemoveFromMyCauses}
          className={classes.RemoveFromMyCausesModal__button}
          color="cerise"
          loading={isLoading}
          disabled={isLoading}
        >
          Remove from My Causes
        </ButtonMantine>
      </Stack>
    </Modal>
  );
};

export { RemoveFromMyCausesModal };
